import { writable } from "svelte/store";
import { DashboardService } from "../../services/dashboard.service";
import { nvpToChart } from "../../utils/misc/chart-utils";
export const recentActivitiesDays = 15;
export const tiles = writable(null);
export const expDossiersloading = writable(false);
export const expDossiersRecords = writable([]);
export const dossiersByTypeGlobal = writable(nvpToChart([]));
export const dossiersByTypeYear = writable(nvpToChart([]));
export const numRecentActivities = writable(nvpToChart([]));
export function loadDashboard() {
    loadTiles();
    loadExpiringDossiers();
    loadDossiersByTypeGlobal();
    //loadDossiersByTypeYear();
    loadNumRecentActivities();
}
async function loadTiles() {
    let _resp = await DashboardService.getDashboardTiles();
    tiles.set(_resp.payload);
}
async function loadExpiringDossiers() {
    expDossiersloading.set(true);
    try {
        let _resp = await DashboardService.getExpiringDossiers();
        expDossiersRecords.set(_resp.payload);
    }
    finally {
        expDossiersloading.set(false);
    }
}
async function loadDossiersByTypeGlobal() {
    let _resp = await DashboardService.getDossiersByTypeGlobal();
    dossiersByTypeGlobal.set(nvpToChart(_resp.payload));
}
async function loadDossiersByTypeYear() {
    let _resp = await DashboardService.getDossiersByTypeYear();
    dossiersByTypeYear.set(nvpToChart(_resp.payload));
}
async function loadNumRecentActivities() {
    let _resp = await DashboardService.getNumRecentActivities(recentActivitiesDays);
    numRecentActivities.set(nvpToChart(_resp.payload));
}
